import { Controller } from "@hotwired/stimulus"
import { showHubTeamToast } from "../utils/hub_team_toast"

// Sending an invitation changes a member's status badge, their available row actions and the
// awaiting-invitation count all at once, so a successful send reloads the server-rendered page
// rather than reproducing those states in JavaScript.
export default class extends Controller {
  static targets = ["pendingCount"]
  static values = { pendingUrl: String }

  sendPending(event) {
    event.preventDefault()

    const count = this.pendingCount()
    if (count === 0 || !this.hasPendingUrlValue) return

    const noun = count === 1 ? "member" : "members"
    if (!window.confirm(`Send invitation emails to ${count} ${noun}?`)) return

    this.send(event.currentTarget, this.pendingUrlValue, "Failed to send invitations")
  }

  sendRow(event) {
    event.preventDefault()

    const button = event.currentTarget
    const row = button.closest("tr")
    const url = row?.dataset.sendInvitationUrl
    if (!url) return

    const memberName = row.querySelector(".hub-team-member-name-text")?.textContent?.trim() || "this member"
    if (!window.confirm(`Send an invitation email to ${memberName}?`)) return

    this.send(button, url, "Failed to send invitation")
  }

  async send(button, url, errorPrefix) {
    if (button.disabled) return

    button.disabled = true

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content,
          "Accept": "application/json"
        },
        credentials: "same-origin"
      })

      const data = await response.json()

      if (response.ok && data.success) {
        window.location.reload()
        return
      }

      const message = data?.errors?.join(", ") || `HTTP ${response.status}`
      showHubTeamToast(`${errorPrefix}: ${message}`, { variant: "error" })
    } catch (error) {
      console.error("Error sending company member invitations:", error)
      showHubTeamToast("An error occurred. Please try again.", { variant: "error" })
    }

    button.disabled = false
  }

  pendingCount() {
    if (!this.hasPendingCountTarget) return 0

    return parseInt(this.pendingCountTarget.textContent, 10) || 0
  }
}
